import Component from '@glimmer/component';
import { action } from '@ember/object';
import { assert } from '@ember/debug';
import { isNone } from '@ember/utils';
import { underscore } from '@ember/string';
import type Owner from '@ember/owner';

interface AditoolsMenuTabSignature {
  Element: HTMLLIElement;
  Args: {
    label: string;
    tab: string;
    icon: string;
    activeTab: string;
    enabledTabs: string[];
    select: (arg0: string) => void;
    svg?: string;
    qaName?: string;
  };
}
type AditoolsMenuTabArgs = AditoolsMenuTabSignature['Args'];

export default class AditoolsMenuTab extends Component<AditoolsMenuTabSignature> {
  constructor(owner: Owner, args: AditoolsMenuTabArgs) {
    super(owner, args);
    assert('`label` is required', !isNone(this.args.label));
    assert('`tab` is required', !isNone(this.args.tab));
    assert('`activeTab` is required', !isNone(this.args.activeTab));
    assert('`enabledTabs` is required', !isNone(this.args.enabledTabs));
    assert('`select` is required', !isNone(this.args.select));
    assert('Either `svg` or `icon` is required', !isNone(this.args.icon) || !isNone(this.args.svg));
  }

  get hasSVG(): boolean {
    return !isNone(this.args.svg);
  }

  get isActive(): boolean {
    return this.args.activeTab === this.args.tab && this.args.enabledTabs.includes(this.args.tab);
  }

  get isEnabled() {
    return this.args.enabledTabs.includes(this.args.tab);
  }

  get isDisabled() {
    return !this.isEnabled;
  }

  get qaTabName() {
    return this.args.qaName || underscore(this.args.tab.toLowerCase());
  }

  @action keyPressed(event: KeyboardEvent) {
    if (['Enter', ' '].includes(event.key) && this.isEnabled) {
      this.args.select(this.args.tab);
    }
  }

  @action clicked() {
    this.args.select(this.args.tab);
  }
}
